import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { getAbstractData } from "../../../../services/event/dashboard/dashboardServices";

const AbstractSubmittedChart = (props) => {
  const { startMonth, endMonth, subDomain,filterField } = props;

  const [chartData, setChartData] = useState({
    series: [
      {
        name: "",
        data: [],
        color: "#FF9800", // Orange
      },
    ],
    options: {},
  });
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAbstractData({ sub_domain: subDomain?subDomain :"", filterField: filterField ,fromDate: startMonth, toDate: endMonth  });
        const countries = response?.data.map((item) => item.country);
        const counts = response?.data.map((item) => parseInt(item.count));
        setChartData((prevData) => ({
          ...prevData,
          series: [{ name: "series-1", data: counts, color: "#FF9800" }],
          options: {
            ...prevData.options,
            chart: {
              type: "bar",
              height: "100%",
              width: "100%",
            },
            title: {
              ...prevData.options.title,
              text: `Total Abstract Submitted: ${counts.reduce(
                (a, b) => a + b,
                0
              )}`,
              style: {
                fontSize: "16px",
                fontWeight: 800,
                color: "#333",
              },
            },
            xaxis: { categories: countries },

            plotOptions: {
              bar: {
                horizontal: true, // Horizontal bar chart
                borderRadius: 3,
              },
            },
            dataLabels: {
              enabled: false,
            },
          },
        }));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [startMonth,endMonth,filterField,subDomain]);

  return (
    <>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={props.height}
      />
    </>
  );
};

export default AbstractSubmittedChart;
